import { useState } from 'react';
import { PublicService } from './ServiceModal';

type ServiceMenuProps = {
    services: PublicService[];
    money: (value?: number) => string;
    duration: (minutes?: number) => string;
    onOpen: (service: PublicService) => void;
};

// Acima disso a lista recolhe, para os servicos nao empurrarem o resto da pagina.
const VISIBLE_LIMIT = 8;

// Tabela de precos no estilo de barbearia: nome, pontilhado e valor; a foto so aparece quando existe.
export function ServiceMenu({ services, money, duration, onOpen }: ServiceMenuProps) {
    const [expanded, setExpanded] = useState(false);
    const visible = expanded ? services : services.slice(0, VISIBLE_LIMIT);

    return (
        <>
            <ul className="grid grid-cols-1 lg:grid-cols-2 lg:gap-x-14">
                {visible.map((service) => {
                    const cover = service.images[0];
                    const details = [duration(service.duration), service.description].filter(Boolean).join(' · ');
                    return (
                        <li key={service.id} className="border-b border-base-content/[0.08]">
                            <button
                                type="button"
                                onClick={() => onOpen(service)}
                                className="group flex w-full items-center gap-4 py-4 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary sm:py-5"
                            >
                                {cover && (
                                    <img src={cover} alt="" loading="lazy" className="h-14 w-14 shrink-0 rounded-xl bg-base-300 object-cover" />
                                )}
                                <span className="min-w-0 flex-1">
                                    <span className="flex items-baseline gap-2">
                                        <span className="min-w-0 break-words text-[1.0625rem] font-semibold leading-snug transition-colors group-hover:text-primary">
                                            {service.name}
                                        </span>
                                        {service.requiresSubscription && (
                                            <span className="shrink-0 rounded-full bg-primary/10 px-2 py-0.5 text-[0.6875rem] font-semibold text-primary">Assinantes</span>
                                        )}
                                        <span aria-hidden className="min-w-4 flex-1 -translate-y-1 border-b border-dotted border-base-content/25"></span>
                                        <span className="shrink-0 text-[1.0625rem] font-semibold tabular-nums">{money(service.price)}</span>
                                    </span>
                                    {details && <span className="mt-1 line-clamp-2 text-sm text-base-content/55 lg:line-clamp-1">{details}</span>}
                                </span>
                            </button>
                        </li>
                    );
                })}
            </ul>
            {services.length > VISIBLE_LIMIT && (
                <div className="mt-6 text-center">
                    <button
                        type="button"
                        onClick={() => setExpanded((value) => !value)}
                        aria-expanded={expanded}
                        className="btn h-11 min-h-11 rounded-full border-0 bg-base-100 px-6 text-sm ring-1 ring-base-content/10 hover:bg-base-100/70"
                    >
                        {expanded ? 'Ver menos' : `Ver todos os ${services.length} serviços`}
                    </button>
                </div>
            )}
        </>
    );
}
